import { Injectable } from '@angular/core';
import { NgxCookiebotService } from '@halloverden/ngx-cookiebot';
import { filter } from 'rxjs/operators';
import { tap } from 'rxjs';
import { FfNgxPiwikProInitializerService } from '@fagforbundet/ngx-components';

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  constructor(
    private readonly _cookiebotService: NgxCookiebotService,
    private readonly _piwikInitializerService: FfNgxPiwikProInitializerService,
  ) {}

  init(): Promise<void> {
    return new Promise<void>((resolve) => {
      this._cookiebotService.onServiceReady$
        .pipe(
          filter((ready: boolean) => {
            return ready;
          }),
          tap(() => {
            this._setUpEventHandlers();
          }),
        )
        .subscribe();

      resolve();
    });
  }

  private _setUpEventHandlers(): void {
    this._cookiebotService.onConsentReady$
      .pipe(
        tap((e) => {
          this._handleUserConsent();
        }),
      )
      .subscribe();
  }

  private _handleUserConsent(): void {
    if (this._cookiebotService.cookiebot.consent.statistics) {
      this._piwikInitializerService.init();
    }
  }
}
